import { type ReactElement } from 'react';
import { PsychoCardSkeleton } from 'pages/Appointments/AppointmentsReserve/components/ui/PsychoCard/PsychoCardSkeleton';

const SKELETON_COUNT = 5;

export const DesktopViewSkeleton = (): ReactElement => (
  <div className="flex flex-col gap-4">
    {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
      <PsychoCardSkeleton key={index} />
    ))}
  </div>
);
